/* Overlay fuer Seiten, sitewide (Roadmap 3.3, vorher Teil von mhsys-produkt.js, dort nur auf der
 * Produktseite verfuegbar - die Gruenderkarte auf der Startseite braucht dieselbe Mechanik jetzt
 * auch, siehe unten).
 *
 * Ein Link bekommt data-mhsys-popup (Titel ueber data-mhsys-popup-titel, sonst der Linktext);
 * data-mhsys-groessentabelle bleibt gueltig. data-mhsys-popup-voll zeigt den Inhalt am Handy
 * vollflaechig statt als Bogen von unten - fuer laengere Seiten wie den UWG-Hinweis "Wie werden
 * Bewertungen gesammelt?" (Roadmap 3.3 Paket B, Wunsch des Inhabers 21.09.2026), waehrend
 * Groessentabelle/Grußkarten ihre bisherige, kompaktere Form behalten. Ohne JavaScript bleibt es
 * ein normaler Link - deshalb behaelt jeder Ausloeser sein href, und Strg-/Cmd-/Mittelklick
 * werden nicht abgefangen (neuer Tab statt Overlay).
 *
 * NUR eigene Adressen: der Inhalt kommt per fetch, eine fremde Domain (judge.me) liefert ihn
 * nicht aus - solche Links bleiben normale Links, weil kein data-mhsys-popup an ihnen steht.
 *
 * window.mhsysPopupsVerbinden(wurzel) ist der Verbindungsaufruf fuer andere Skripte: die
 * Schnellansicht (assets/mhsys-produkt.js, window.mhsysProduktKauf) haengt "zzgl. Versand" damit
 * an ihren nachgeladenen Produktblock.
 *
 * Panel, Fokus und Tastatur liegen im Modul, nicht in der Verbinde-Funktion: die laeuft bei
 * jedem shopify:section:load erneut, und je Aufruf ein eigenes Panel hiesse zwei Overlays und
 * ein Escape, das nur das erste schliesst.
 */
(function () {
  'use strict';

  let popupPanel = null;
  /* Nach dem Schliessen geht der Fokus zurueck auf den Link, der geoeffnet hat - sonst landet
     ein Tastatur- oder Screenreader-Nutzer am Seitenanfang */
  let popupZuletzt = null;
  /* Ob das offene Overlay einen eigenen Verlaufseintrag gesetzt hat (Zurueck-Taste schliesst
     statt die Seite zu verlassen, Wunsch des Inhabers 21.09.2026) - NUR bei data-mhsys-popup-voll.
     Groessentabelle/"zzgl. Versand"/Grußkarten bleiben ohne eigenen Verlaufseintrag: die
     Schnellansicht (assets/mhsys-schnellansicht.js) hat ihr eigenes pushState/popstate, und
     "zzgl. Versand" kann dort ALS Popup darueber liegen - zwei Verlaufseintraege und zwei
     popstate-Horcher fuer dieselbe Zurueck-Taste haetten beide Ebenen auf einmal geschlossen oder
     waeren aus dem Takt geraten (MASTER 21.09.2026). Ohne eigene Historie ruehrt dieses Modul bei
     Groessentabelle & Co. an popstate ueberhaupt nichts an - die Schnellansicht prueft dafuer
     selbst auf ein offenes .mhsys-popup (Escape-Zweig). */
  let popupHistorie = false;
  /* Ob dieses Popup den Eintrag darunter mit mhsysOverlayBasis markiert hat (nur mit "verlauf", Roadmap
     4.12): daran erkennt der Geschenkefinder, dass er bei diesem Zurueck nicht auf Frage 4 springt - dasselbe
     Muster wie das Grusskarten-Overlay. Nach dem Schliessen kommt die Markierung wieder weg. */
  let popupBasis = false;

  /* Das xmark-Symbol aus snippets/mhsys-icon.liquid - dasselbe Zeichen an jedem Overlay (Roadmap 4.14) */
  const ZU_SYMBOL = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M5.05 3.9c.3 0 .6.12.83.35L12 10.37l6.12-6.12a1.17 1.17 0 0 1 1.66 1.66L13.66 12l6.12 6.12a1.17 1.17 0 0 1-1.66 1.66L12 13.66l-6.12 6.12a1.17 1.17 0 0 1-1.66-1.66L10.34 12 4.22 5.88A1.17 1.17 0 0 1 5.05 3.9Z"/></svg>';
  window.mhsysZuSymbol = ZU_SYMBOL;

  /* Ladeanzeige (Roadmap 4.14): die Brezn aus mhsys, die aufgegessen wird. Sichtbar erst nach 300 ms - bei
     schnellem Laden erscheint sie nie. Wer sie einsetzt, ersetzt sie spaeter einfach durch den Inhalt. CSS:
     "Ladeanzeige in den Overlays" in mhsys-weissblau.css. Auch fuer Schnellansicht und Grusskarten. */
  function ladeAnzeige(text) {
    const el = document.createElement('div');
    el.className = 'mhsys-laden';
    el.setAttribute('role', 'status');
    el.innerHTML = '<div class="mhsys-laden__brezn" aria-hidden="true"><span class="mhsys-laden__bild"></span>' +
      '<span class="mhsys-laden__biss"></span><span class="mhsys-laden__biss"></span>' +
      '<span class="mhsys-laden__biss"></span><span class="mhsys-laden__biss"></span></div>' +
      '<div class="mhsys-laden__text"></div>';
    el.querySelector('.mhsys-laden__text').textContent = text || 'Wird geladen …';
    setTimeout(() => {
      if (el.isConnected) el.classList.add('mhsys-laden--an');
    }, 300);
    return el;
  }
  window.mhsysLadeAnzeige = ladeAnzeige;

  /* Die Brezn-Grafik vorladen, sobald jemand einen Overlay-Ausloeser antippt - einmal je Seite (Roadmap 4.14).
     Unter "Slow 4G" kam sie beim ersten Overlay sonst erst rund 0,6 s nach "Wird geladen ..." an. Dieselbe
     Adresse, die die Maske in mhsys-weissblau.css aufloest (relativ zur CSS-Datei, ohne ?v=), damit der Browser
     sie aus dem Cache nimmt. Beim Seitenaufruf laedt nichts. */
  const OVERLAY_AUSLOESER = '[data-mhsys-popup], [data-mhsys-groessentabelle], [data-wk-schnellansicht], ' +
    '[data-mhsys-grusskarten-oeffnen], [data-wk-express-hilfe], [data-mhsys-bew-oeffnen], ' +
    '.mhsys-finder__treffer a[href*="/products/"], a[href*="/pages/kontaktformular"], a[href*="/pages/benachrichtigungen"], ' +
    'a[href*="/pages/newsletter"]';
  let breznGeholt = false;
  function breznVorladen(e) {
    if (breznGeholt || !(e.target instanceof Element) || !e.target.closest(OVERLAY_AUSLOESER)) return;
    breznGeholt = true;
    const css = document.querySelector('link[rel="stylesheet"][href*="mhsys-weissblau.css"]');
    if (!css) return;
    try {
      const bild = new Image();
      /* CORS wie die Maske - sonst zwei getrennte Cache-Eintraege und die Grafik kaeme zweimal (gemessen) */
      bild.crossOrigin = 'anonymous';
      bild.src = new URL('mhsys-brezn.svg', css.href).href;
    } catch (fehler) {}
  }
  document.addEventListener('pointerdown', breznVorladen, { capture: true, passive: true });
  document.addEventListener('touchstart', breznVorladen, { capture: true, passive: true });

  /* Kopfzeile (Roadmap 4.14): Titel und x in einer Zeile, die beim Scrollen oben kleben bleibt
     (.mhsys-ueberlage__kopfzeile) - sonst scrollte bei offener Handy-Tastatur der eigene x-Knopf weg und nur der
     der Schublade dahinter blieb zu sehen (MASTER 22.09.2026). Die erste Ueberschrift der geladenen Seite wird
     der Titel, egal wie tief sie in den Abschnitten der Seite steckte; ohne Ueberschrift der Titel des Aufrufs. */
  function kopfSetzen(inhalt, titel) {
    const ziel = popupPanel.querySelector('.mhsys-popup__titel');
    let kopf = inhalt.querySelector('h2, h3');
    if (!kopf) {
      kopf = document.createElement('h2');
      kopf.textContent = titel || '';
    }
    kopf.classList.add('mhsys-ueberlage__kopf');
    ziel.replaceChildren(kopf);
  }

  /* CSS je Baustein (Roadmap 1.56): eine Seite laedt ihre Dateien assets/mhsys-b-*.css nur, wenn ihr Inhalt den
     Baustein enthaelt (snippets/mhsys-css-bausteine.liquid). Die geladene Seite bringt sie in ihrem head mit - fehlt
     eine davon hier, kommt sie dazu, bevor der Inhalt eingesetzt wird; sonst stuende etwa das Kontaktformular auf
     einer Produktseite ohne sein CSS da. Die Regeln darin greifen nur an Klassen des Bausteins, die es auf dieser
     Seite bis dahin nicht gab - am Rest der Seite aendert sich nichts. Hoechstens 3 s warten. Eine einzelne
     Section (data-mhsys-popup-section) hat keinen head; ihr CSS steht im Kern. */
  function bausteinCssLaden(doc) {
    const dateiname = (href) => {
      try {
        return new URL(href, window.location.href).pathname.split('/').pop();
      } catch (fehler) {
        return '';
      }
    };
    const da = new Set(Array.from(document.querySelectorAll('link[rel="stylesheet"]'), (l) => dateiname(l.getAttribute('href'))));
    const neu = Array.from(doc.querySelectorAll('link[rel="stylesheet"][href*="mhsys-b-"]'))
      .map((l) => l.getAttribute('href'))
      .filter((href) => !da.has(dateiname(href)));
    return Promise.all(neu.map((href) => new Promise((fertig) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = fertig;
      link.onerror = fertig;
      window.setTimeout(fertig, 3000);
      document.head.append(link);
    })));
  }

  /* Liefert true, wenn wirklich etwas geschlossen wurde - die Escape-Behandlung unten braucht
     das, um ein daruntergelegtes Overlay (Schnellansicht) nicht versehentlich mitzuschliessen. */
  function popupZu(vonPopstate) {
    if (!popupPanel || popupPanel.hidden) return false;
    popupPanel.hidden = true;
    document.documentElement.classList.remove('mhsys-overlay-offen');
    if (popupHistorie && !vonPopstate && window.history) window.history.back();
    popupHistorie = false;
    if (popupZuletzt && document.contains(popupZuletzt)) popupZuletzt.focus();
    return true;
  }

  /* Kleine Sections (data-mhsys-popup-section) einmal holen und merken: vorgeladen schon beim Antippen bzw.
     Ueberfahren des Ausloesers, beim zweiten Oeffnen sofort da. Ein Fehler wird nicht gemerkt. */
  const sectionSpeicher = new Map();
  function sectionHolen(url, section) {
    const abruf = url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + encodeURIComponent(section);
    if (!sectionSpeicher.has(abruf)) {
      const p = fetch(abruf).then((r) => {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      });
      p.catch(() => sectionSpeicher.delete(abruf));
      sectionSpeicher.set(abruf, p);
    }
    return sectionSpeicher.get(abruf);
  }
  function sectionVorladen(e) {
    const a = e.target instanceof Element ? e.target.closest('[data-mhsys-popup-section][href]') : null;
    if (a) sectionHolen(a.getAttribute('href'), a.dataset.mhsysPopupSection).catch(() => {});
  }
  document.addEventListener('pointerover', sectionVorladen, { passive: true });
  document.addEventListener('touchstart', sectionVorladen, { capture: true, passive: true });

  /* Skripte fuer Inhalt im Overlay: Skripte der geladenen Seite laufen hier nicht. Ein Element im Inhalt mit
     data-mhsys-popup-skript="<asset_url>" bekommt sein Skript einmal je Seite nachgeladen - das haengt sich selbst ans
     Dokument (Newsletter-Formular, snippets/mhsys-nl-formular.liquid, Inhaber 15.10.2026). Bis 15.10.2026 startete hier
     Shopify Forms im Overlay (08 D19). */
  const popupSkripte = new Set();
  function popupSkripteLaden(inhalt) {
    inhalt.querySelectorAll('[data-mhsys-popup-skript]').forEach((el) => {
      const src = el.getAttribute('data-mhsys-popup-skript');
      if (!src || popupSkripte.has(src)) return;
      popupSkripte.add(src);
      if (document.querySelector('script[src="' + CSS.escape(src) + '"]')) return;
      const s = document.createElement('script');
      s.src = src;
      s.defer = true;
      document.head.append(s);
    });
  }

  /* text statt url (Roadmap 4.13): eine feste Meldung ohne Nachladen - die Bestaetigung des Kontaktformulars */
  function popupOeffnen(url, titel, voll, verlauf, text) {
    if (!url && !text) return;
    if (!popupPanel) {
      popupPanel = document.createElement('div');
      popupPanel.className = 'mhsys-popup';
      popupPanel.innerHTML =
        '<div class="mhsys-popup__schleier" data-zu></div>' +
        '<div class="mhsys-popup__panel" role="dialog" aria-modal="true" tabindex="-1">' +
        '<div class="mhsys-popup__kopf mhsys-ueberlage__kopfzeile"><div class="mhsys-popup__titel"></div>' +
        '<button type="button" class="mhsys-popup__zu mhsys-ueberlage__zu" data-zu aria-label="Schließen">' + ZU_SYMBOL + '</button></div>' +
        '<div class="mhsys-popup__inhalt mhsys-rte"></div></div>';
      popupPanel.addEventListener('click', (e) => {
        if (e.target.closest('[data-zu]') || !e.target.closest('.mhsys-popup__panel')) popupZu();
      });
      document.body.appendChild(popupPanel);
    }
    popupPanel.classList.toggle('mhsys-popup--voll', !!voll);
    popupPanel.classList.remove('mhsys-popup--kontakt');
    const kasten = popupPanel.querySelector('.mhsys-popup__panel');
    kasten.setAttribute('aria-label', titel || 'Information');
    const inhalt = popupPanel.querySelector('.mhsys-popup__inhalt');
    inhalt.replaceChildren(ladeAnzeige());
    popupPanel.querySelector('.mhsys-popup__titel').replaceChildren();
    popupPanel.hidden = false;
    document.documentElement.classList.add('mhsys-overlay-offen');
    kasten.focus();

    popupHistorie = false;
    if (text) {
      const p = document.createElement('p');
      p.textContent = text;
      inhalt.replaceChildren(p);
      kopfSetzen(inhalt, titel);
      return;
    }
    /* verlauf (Roadmap 4.12): eigener Verlaufseintrag auch ohne Vollbild - die Express-Info aus der
       Warenkorb-Schublade soll wie die Grusskarten per Zurueck-Taste zugehen, die Schublade bleibt offen. */
    if (verlauf && !popupBasis && window.history && window.history.replaceState) {
      try {
        window.history.replaceState(Object.assign({}, window.history.state || {}, { mhsysOverlayBasis: true }), '');
        popupBasis = true;
      } catch (e) {}
    }
    if ((voll || verlauf) && window.history && window.history.pushState) {
      /* Bestehenden Zustand mitnehmen, nicht ersetzen: liegt das Popup ueber der Schnellansicht
         (die beim Oeffnen selbst schon {mhsysSchnellansicht: '<handle>'} gesetzt hat, assets/
         mhsys-schnellansicht.js), wuerde ein Ersetzen den Finder-Stand fuer ihren eigenen
         popstate-Zweig verschlucken - Vorschlag Tuva 21.09.2026. */
      const eigen = Object.assign({}, window.history.state || {}, { mhsysPopup: true });
      delete eigen.mhsysOverlayBasis;
      window.history.pushState(eigen, '', window.location.href);
      popupHistorie = true;
    }

    /* data-mhsys-popup-section am Ausloeser: nur diese Section holen (Section Rendering API) statt der ganzen
       Seite - die Express-Kurzfassung sind wenige KB, die Seite 214 KB (Inhaber 26.09.2026: "laedt relativ lange") */
    const nurSection = popupZuletzt && popupZuletzt.dataset && popupZuletzt.dataset.mhsysPopupSection;
    /* Rueckfall: liefert die Section nichts (Kennung veraltet, 404), die ganze Seite holen */
    (nurSection
      ? sectionHolen(url, nurSection).catch(() => fetch(url).then((r) => r.text()))
      : fetch(url).then((r) => r.text()))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return bausteinCssLaden(doc).then(() => doc);
      })
      .then((doc) => {
        const quelle =
          doc.querySelector('[data-mhsys-seiteninhalt]') ||
          doc.querySelector('main') ||
          doc.body;
        /* Die H1 der eingebundenen Seite wird zu H2 - es darf nur eine H1 je Seite geben
           (docs/relaunch/04 Abschnitt 4) */
        quelle.querySelectorAll('h1').forEach((h1) => {
          const h2 = document.createElement('h2');
          /* Klasse mitnehmen (Roadmap 4.13): ohne sie verlor die Kontakt-Ueberschrift ihr blaues "sofort"
             (.mhsys-inhalt__titel em) und stand kursiv da */
          h2.className = h1.className;
          h2.innerHTML = h1.innerHTML;
          h1.replaceWith(h2);
        });
        /* data-mhsys-popup-teil (Newsletter, 15.10.2026): steht das an Teilen der geladenen Seite, kommen nur sie ins
           Overlay - vom Newsletter nur Ueberschrift, Satz und Formular, nicht Vorteile, Schritte und Fragen darunter */
        const teile = quelle.querySelectorAll('[data-mhsys-popup-teil]');
        const knoten = teile.length ? Array.from(teile) : Array.from(quelle.childNodes);
        inhalt.replaceChildren(...knoten.map((n) => document.importNode(n, true)));
        kopfSetzen(inhalt, titel);
        popupSkripteLaden(inhalt);
        /* Skripte der geladenen Seite laufen im Overlay nicht - wer im Inhalt etwas zum Leben erwecken muss (die
           Benachrichtigungen, assets/mhsys-benachrichtigung.js), horcht auf dieses Ereignis. Synchron, also noch vor dem
           naechsten Bild: kein Umspringen sichtbar. */
        document.dispatchEvent(new CustomEvent('mhsys:popup-inhalt', { detail: { wurzel: inhalt, url: url } }));
        /* Größentabelle: ?tabelle=damen am Link waehlt den Reiter vor (sections/mhsys-groessentabelle.liquid) -
           Skripte der geladenen Seite laufen hier nicht, deshalb setzt das Overlay den Radio-Knopf selbst */
        const reiter = new URL(url, window.location.href).searchParams.get('tabelle');
        if (reiter) {
          const wahl = inhalt.querySelector('[data-mhsys-gt-reiter="' + reiter.replace(/[^a-z0-9-]/gi, '') + '"]');
          if (wahl) wahl.checked = true;
        }
        /* Kontaktformular im Overlay (Roadmap 4.13): kompakter, damit am Handy das erste Feld im ersten Bild steht */
        popupPanel.classList.toggle('mhsys-popup--kontakt', !!inhalt.querySelector('#ContactForm'));
      })
      .catch(() => {
        inhalt.textContent = 'Der Inhalt lässt sich gerade nicht laden.';
      });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      /* stopImmediatePropagation NUR wenn hier wirklich etwas zuging: andere Escape-Horcher auf
         demselben document (die Schnellansicht, assets/mhsys-schnellansicht.js) pruefen selbst
         auf ein offenes .mhsys-popup, um zu wissen, ob SIE sich schliessen sollen - ohne den
         Stopp haette ihr Zweig nach diesem Schliessen faelschlich "nichts mehr offen" gesehen und
         sich gleich mitgeschlossen (live gefunden 21.09.2026, verschachtelt in der Schnellansicht:
         "zzgl. Versand" als Popup darueber). War kein Popup offen, bleibt die Weitergabe normal -
         dann darf/soll z. B. die Schnellansicht selbst auf Escape reagieren. */
      if (popupZu()) e.stopImmediatePropagation();
      return;
    }
    /* Fokusfalle: aria-modal allein haelt die Tab-Taste nicht im Popup (Funktionstest h10) */
    if (e.key !== 'Tab' || !popupPanel || popupPanel.hidden) return;
    const kasten = popupPanel.querySelector('.mhsys-popup__panel');
    const ziele = [...kasten.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent !== null);
    if (!ziele.length) return;
    const erstes = ziele[0];
    const letztes = ziele[ziele.length - 1];
    const drin = kasten.contains(document.activeElement) && document.activeElement !== kasten;
    if (e.shiftKey && (!drin || document.activeElement === erstes)) {
      e.preventDefault();
      letztes.focus();
    } else if (!e.shiftKey && (!drin || document.activeElement === letztes)) {
      e.preventDefault();
      erstes.focus();
    }
  });

  window.addEventListener('popstate', (e) => {
    if (popupBasis && e.state && e.state.mhsysOverlayBasis && !e.state.mhsysPopup) {
      const ohne = Object.assign({}, e.state);
      delete ohne.mhsysOverlayBasis;
      try { window.history.replaceState(ohne, ''); } catch (err) {}
      popupBasis = false;
    }
    if (!popupPanel || popupPanel.hidden) return;
    /* Voll-Popup mit eigenem Verlaufseintrag: nur schliessen, wenn der Zielzustand unseren
       Schluessel wirklich nicht mehr traegt (Tuva 21.09.2026, dasselbe Muster wie ihr
       mhsysSchnellansicht). Ein Popup OHNE eigenen Verlaufseintrag (Groessentabelle, "zzgl.
       Versand") besitzt keinen Schritt, den es selbst "haelt" - liegt es aber innerhalb eines
       Overlays mit eigener Historie (Schnellansicht) und die schliesst sich per Zurueck-Taste,
       bliebe es sonst als verwaiste Vollflaeche auf dem Bildschirm stehen (live gefunden,
       21.09.2026) - deshalb schliesst es bei jedem fremden popstate mit. */
    if (popupHistorie && e.state && e.state.mhsysPopup) return;
    popupZu(true);
  });

  function popupsVerbinden(wurzel) {
    wurzel.querySelectorAll('[data-mhsys-groessentabelle], [data-mhsys-popup]').forEach((a) => {
      if (a.dataset.mhsysPopupBereit) return;
      a.dataset.mhsysPopupBereit = '1';
      a.addEventListener('click', (e) => {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        popupZuletzt = a;
        popupOeffnen(a.getAttribute('href'), a.dataset.mhsysPopupTitel || (a.textContent || '').trim(), 'mhsysPopupVoll' in a.dataset, 'mhsysPopupVerlauf' in a.dataset);
      });
    });
  }

  window.mhsysPopupsVerbinden = popupsVerbinden;

  /* Oeffnen aus fremdem Code (Roadmap 4.12: die Express-Info der Warenkorb-Schublade - ihr Link sitzt in
     einer Label-Zeile, die Schublade faengt den Klick deshalb selbst ab und kann kein data-mhsys-popup nutzen).
     optionen: { voll, verlauf, ausloeser } - ausloeser bekommt nach dem Schliessen den Fokus zurueck. */
  /* Seiten, die IMMER als Overlay aufgehen - ueber die Adresse, nicht ueber ein Attribut am Link: ein Klick auf jeden
     eigenen Link dorthin (Seitentexte, Knoepfe, Kopf, Fuss, Menue, Handyleiste) oeffnet die Seite als hohen Schuber
     (am Handy von unten, Zurueck-Taste schliesst).
     - Kontaktformular (Inhaber 26.09.2026: "Immer wenn du irgendwo auf Kontaktformular verlinkst, öffne im Overlay")
     - Benachrichtigungen (Inhaber 15.10.2026: "Push aufs Handy immer mit overlay öffnen, überall im Shop"). Die Logik
       haengt sich ueber das Ereignis mhsys:popup-inhalt an (assets/mhsys-benachrichtigung.js).
     - Newsletter (Inhaber 15.10.2026: "Newsletter auch im overlay öffnen"); das eigene Formular bringt sein Skript ueber
       data-mhsys-popup-skript mit (popupSkripteLaden() oben).
     Links mit eigenem Overlay (data-mhsys-popup) haben den Klick schon abgefangen (defaultPrevented). Auf der Seite
     selbst, bei Strg-/Cmd-/Mittelklick und an Links mit data-mhsys-kein-overlay (der Weg aus dem Overlay auf die
     Seite) bleibt es der normale Link. Wer ein neues Ziel einfuehrt, braucht nichts zu tun, solange die Adresse gleich
     bleibt; eine weitere Seite kommt als Zeile in diese Liste. */
  const OVERLAY_SEITEN = [
    { pfad: '/pages/kontaktformular', titel: 'Kontakt' },
    { pfad: '/pages/benachrichtigungen', titel: 'Benachrichtigungen' },
    { pfad: '/pages/newsletter', titel: 'Newsletter' },
  ];
  const overlaySeite = (pfad) => {
    const p = pfad.replace(/\/$/, '');
    return OVERLAY_SEITEN.find((s) => p.endsWith(s.pfad));
  };
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target instanceof Element ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download') || a.hasAttribute('data-mhsys-kein-overlay')) return;
    let ziel;
    try {
      ziel = new URL(a.getAttribute('href'), window.location.href);
    } catch (f) {
      return;
    }
    if (ziel.origin !== window.location.origin) return;
    const seite = overlaySeite(ziel.pathname);
    if (!seite || overlaySeite(window.location.pathname) === seite) return;
    e.preventDefault();
    popupZuletzt = a;
    popupOeffnen(ziel.pathname + ziel.search, seite.titel, true, true);
  });

  window.mhsysPopupOeffnen = (url, titel, optionen) => {
    const o = optionen || {};
    popupZuletzt = o.ausloeser || document.activeElement;
    popupOeffnen(url, titel, !!o.voll, !!o.verlauf);
  };

  /* Kontaktformular aus dem Overlay abgeschickt (Roadmap 4.13, "Fragen?" in der Handyleiste): abgeschickt wird
     bewusst normal, nicht per fetch - Shopifys hCaptcha haengt sich per focusin selbst an das Formular und haelt
     jedes Absenden bis zur Pruefung auf; ein eigener fetch wuerde daran vorbei oder dagegen laufen. Shopify
     leitet danach mit ?contact_posted=true zurueck. Steht auf der Zielseite kein Formular (dort zeigt es seine
     Meldung selbst), kommt der Dank als Overlay, und der Parameter verschwindet aus der Adresse - ein Neuladen
     wiederholt die Meldung nicht. */
  function kontaktBestaetigen() {
    let gesendet = null;
    try {
      gesendet = new URLSearchParams(window.location.search).get('contact_posted');
    } catch (e) {}
    if (gesendet !== 'true' || document.getElementById('ContactForm')) return;
    const text = (window.mhsysShop || {}).kontaktGesendet;
    if (!text) return;
    popupZuletzt = null;
    popupOeffnen(null, 'Danke!', false, false, text);
    try {
      const u = new URL(window.location.href);
      u.searchParams.delete('contact_posted');
      u.hash = '';
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (e) {}
  }

  const start = () => {
    popupsVerbinden(document);
    kontaktBestaetigen();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => popupsVerbinden(e.target || document));
})();
